import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useSelector } from 'react-redux';

export default function Code(props) {
  const theme = useTheme();

  const codeArrayState = useSelector((state) => state.challenge.codeArray);
  const selectedCellState = useSelector((state) => state.challenge.selectedCell);

  const normalSelectorStyling = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    borderColor: '#3B4E68',
    borderStyle: 'solid',
    width: '15%',
    height: '100%',
    aspectRatio: '1 / 1',
    backgroundColor: 'rgb(229 231 235)',
    color: '#3B4E68',
    fontSize: '1.5rem',
    lineHeight: '2rem',
    fontWeight: '700',
  };

  const showSelectorStyling = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px',
    borderColor: '#3B4E68',
    borderStyle: 'solid',
    borderWidth: '2px',
    width: '15%',
    height: '100%',
    aspectRatio: '1 / 1',
    // backgroundColor: 'rgb(229 231 235)',
    backgroundColor: '#FFFFFF',
    color: '#3B4E68',
    fontSize: '1.5rem',
    lineHeight: '2rem',
    fontWeight: '700',
  };

  return (
    <Box
      key={`code-row`}
      sx={{
        display: 'flex',
        padding: '20px',
        // paddingBottom: '10px',
        // paddingTop: props.location == 'joystick' ? '0px' : '15px',
        paddingTop: '10px',
        // paddingBottom: '8px',
        paddingBottom: '10px',
        // width: 'max-content',
        width: '100%',
        justifyContent: 'space-between',
        alignSelf: 'center',
        backgroundColor: 'rgb(156, 163, 175)',
      }}
    >

      {codeArrayState.map((digit, digitIndex) => (
        <Box
          key={`grid-code${digitIndex}`}
          id={`grid-code${digitIndex}`}
          sx={props.showSelectorCell && digitIndex == selectedCellState ? showSelectorStyling : normalSelectorStyling}
        // sx={{
        //   display: 'flex',
        //   justifyContent: 'center',
        //   alignItems: 'center',
        //   padding: '5px',
        //   borderColor: '#3B4E68',
        //   borderStyle: 'solid',
        //   width: '15%',
        //   height: '100%',
        //   aspectRatio: '1 / 1',
        //   backgroundColor: 'rgb(229 231 235)',
        //   color: '#3B4E68',
        //   fontSize: '1.5rem',
        //   lineHeight: '2rem',
        //   fontWeight: '700',
        // }}
        >
          {digit}
        </Box>
      ))
      }

    </Box >
  )


}